<template>
  <div>
    <b-modal
      id="modal-catalog"
      ref="modal_catalog"
      :title="title"
      size="lg"
      modal-class="custom-modal"
      centered
      lazy
      no-close-on-backdrop
      no-close-on-esc
      @hidden="onHidden"
    >
      <b-skeleton-wrapper  :loading="isBusy">
        <template #loading>
          <b-form>
            <b-row class="mt-2">
              <b-col>
                <b-skeleton width="40%" height="16%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="30%" class="mb-2"/>
                <b-skeleton width="85%" height="15%" class="mb-0"/>
              </b-col>
            </b-row>
            <slot name="optional-skeleton"></slot>
            <b-row>
              <b-col>
                <b-skeleton type="input" width="30%" height="45%"/>
              </b-col>
            </b-row>
          </b-form>
        </template>

        <template #default>
          <b-form @submit.prevent="handleOk">
            <b-form-group
              id="group-name"
              :label="nameLabel"
              :invalid-feedback="nameInvalidFeedback"
              :state="nameState"
              :description="descriptionLabel"
            >
              <b-form-input
                type="text"
                size="sm"
                v-model="newItem.name"
                :state="nameState"
                :disabled="isViewMode"
                trim
              />
            </b-form-group>

            <slot name="optional-fields" :model="newItem" :disabled="isViewMode"/>

            <b-form-checkbox class="mt-2" size="md" v-model="newItem.active" :disabled="isViewMode || isCreateMode">Активен / не активен</b-form-checkbox>
          </b-form>
        </template>
      </b-skeleton-wrapper>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button class="custom-btn-secondary mr-2" @click="handleCancel">
            {{ isViewMode ? 'Закрыть' : 'Отменить' }}
          </b-button>
          <b-button v-if="!isViewMode" class="custom-btn-primary" :disabled="loading" @click="handleOk">
            <b-spinner v-if="loading" small/>
            Сохранить
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import helpers from "../../utilites/helpers";

export default {
  name: "Catalog",
  mixins: [ helpers ],
  props: {
    title: {type: String, required: true},
    nameLabel: {type: String, required: true},
    descriptionLabel: {type: String, required: false},
    submitError: {type: String, required: true},
    fetchData: {type: Function, required: true},
    putData: {type: Function, required: true},
    postData: {type: Function, required: true},
    exactId: { type: Number, default: null },
    minNameLength: { type: Number, default: 3 },
  },
  emits: ['refresh', 'modal-closed'],
  data() {
    return {
      newItem: this.setNewItem(),
      isBusy: false,
      loading: false
    }
  },
  async mounted() {
    await this.showModal();
  },
  computed: {
    isViewMode() {
      return this.$route.name && this.$route.name.endsWith('View');
    },
    isCreateMode() {
      return !this.newItem.id || this.newItem.id === 0;
    },
    nameState() {
      return this.newItem.name.trim().length >= this.minNameLength;
    },
    nameInvalidFeedback() {
      return `Минимум символов: ${this.minNameLength}`;
    },
  },
  methods: {
    setNewItem() {
      return {
        id: 0,
        name: '',
        short_name: '',
        vacancy: '',
        active: true
      };
    },
    async showModal() {
      this.$refs.modal_catalog.show();
      const id = this.exactId !== null ? this.exactId : this.$route.params.id;

      if (id && id > 0) {
        await this.getCatalog(id);
      } else {
        this.newItem = this.setNewItem();
      }
    },
    hideModal() {
      this.$refs.modal_catalog.hide();
    },
    handleOk() {
      this.handleSubmit();
    },
    handleCancel() {
      this.hideModal();
    },
    onHidden() {
      this.$emit('modal-closed');
    },
    async getCatalog(id) {
      this.isBusy = true;
      this.loading = true;
      const result = await this.fetchData(id);
      this.isBusy = false;
      this.loading = false;

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      this.newItem = result.data;
    },
    async handleSubmit() {
      if (this.newItem.name === '') {
        this.showError(this.submitError);
        return;
      }

      if (!this.nameState) {
        this.showError(`Название слишком короткое. ${this.nameInvalidFeedback}`);
        return;
      }

      this.loading = true;
      const data = {...this.newItem};

      const result = data.id > 0 ? await this.putData(data) : await this.postData(data);

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Не удалось сохранить данные.");
        this.loading = false;
        return;
      }

      const savedItem = {...data, ...result.data};

      this.$emit('refresh', savedItem);
      this.hideModal();
      this.loading = false;
    },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Catalog.vue